import { useState } from "react"

export const useOpenComponent = ( initialState = false ) => {
   const [isOpen, setIsOpen] = useState( initialState )

   const handleIsOpen = () => {
      setIsOpen(!isOpen)
   }

   const handleOpenControlled = (value) => {
      setIsOpen(value)
   }
   return { isOpen, handleIsOpen, handleOpenControlled }
}